module.exports = __webpack_public_path__ + "static/media/futbol-loan.86d023a8.jpg";